<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {
  },
}
</script>

<style lang="scss">
@import "./assets/css/layout.shared";

.page-wrapper {
  //margin-top: 150px;
  //padding: 0 0 0 15px;
}

.content-desktop {
  //display: none;
}

@media screen and (min-width: $screen-lg) {
  .content-mobile {
    //display: none;
  }

  .content-desktop {
    //display: block;
  }

  .page-wrapper {
    //height: calc(100vh - 130px);
    //margin-top: 0;
    //overflow-y: auto;
    //position: relative;
    //padding: 130px 0 0 15%;
    //width: 60%;
  }
}

@media screen and (min-width: $screen-xl) {
  .page-wrapper {
    //margin-top: 0;
    //padding: 130px 0 0 10%;
  }
}
</style>
